import { LayoutCards } from '@flatsy/core/Layout/Cards'
import { Modal, Portal } from '@material-ui/core'
import React from 'react'
import Header from './Header'
import DropZone from './DropZone'
import Footer from './Footer'
import { useStyles } from './Style'
import { UploaderType } from './Type'
import List from './List'

const UploadModal: React.FC<UploaderType> = ({ open }): React.ReactElement => {
  const classes = useStyles()
  if (!open) {
    return <></>
  }
  return (
    <Portal>
      <Modal open className={classes.modal}>
        <div className={classes.modalInner}>
          <LayoutCards strongShadow className={classes.cards}>
            <div className={classes.inner}>
              <Header />
              <DropZone />
              <List />
              <Footer />
            </div>
          </LayoutCards>
        </div>
      </Modal>
    </Portal>
  )
}

export default UploadModal
